import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not_found" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "title" }, "Page Not Found", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "subtitle" }, "The page you're looking for doesn't exist.", -1)),
    _createVNode(_component_base_button, {
      onClick: _ctx.goHome,
      mode: "primary"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Go to Dashboard", -1)
      ]))]),
      _: 1
    }, 8, ["onClick"])
  ]))
}